/* src/app/modules/taxes/fiscal-closure/fiscal-closure-list/fiscal-closure-list.component.css */
:host {
  --fc-brand: #e3fd64;
  --fc-brand-bg: rgba(227, 253, 100, 0.08);
  --fc-text: #1a1d23;
  --fc-muted: #6b7280;
  --fc-border: #e5e7eb;
  --fc-surface: #ffffff;
  --fc-bg: #f4f6f8;
  --fc-radius: 10px;
  --fc-shadow: 0 1px 4px rgba(0,0,0,0.06);
  --fc-open: #16a34a;
  --fc-open-bg: rgba(22, 163, 74, 0.08);
  --fc-closed: #6b7280;
  --fc-closed-bg: rgba(107, 114, 128, 0.10);
  display: block;
}
.fc-page {
  padding: 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.fc-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  background: rgba(245, 158, 11, 0.07);
  border: 1px solid rgba(245, 158, 11, 0.25);
  border-left: 4px solid #f59e0b;
  border-radius: var(--fc-radius);
  font-size: 13px;
  color: var(--fc-text);
}
.fc-notice mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #f59e0b;
  flex-shrink: 0;
  margin-top: 1px;
}
.fc-btn-danger {
  color: #dc2626 !important;
  border-color: rgba(220, 38, 38, 0.35) !important;
}
.fc-quarters {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.fc-quarter-row {
  display: flex;
  align-items: stretch;
  background: var(--fc-surface);
  border: 1px solid var(--fc-border);
  border-radius: var(--fc-radius);
  box-shadow: var(--fc-shadow);
  overflow: hidden;
  min-height: 72px;
}
.fc-q-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 14px 20px;
  background: var(--fc-bg);
  border-right: 1px solid var(--fc-border);
  flex-shrink: 0;
  width: 110px;
  gap: 2px;
}
.fc-q-badge {
  font-size: 20px;
  font-weight: 800;
  color: var(--fc-brand);
  line-height: 1;
}
.fc-q-range {
  font-size: 11px;
  color: var(--fc-muted);
  white-space: nowrap;
}
.fc-q-status-count {
  font-size: 10.5px;
  font-weight: 600;
  color: var(--fc-open);
  margin-top: 2px;
}
.fc-q-status-count--closed {
  color: var(--fc-closed);
}
.fc-q-months {
  display: flex;
  flex: 1;
}
.fc-q-month {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-right: 1px solid var(--fc-border);
  transition: background 0.12s;
}
.fc-q-month:last-child {
  border-right: none;
}
.fc-q-month--open {
  border-top: 2px solid var(--fc-open);
}
.fc-q-month--closed {
  border-top: 2px solid var(--fc-closed);
  background: rgba(107, 114, 128, 0.03);
}
.fc-q-month--selected {
  background: rgba(227, 253, 100, 0.05);
  border-top-color: var(--fc-brand);
}
.fc-q-month__lock {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: var(--fc-closed);
  flex-shrink: 0;
}
.fc-q-month__info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.fc-q-month__name {
  font-size: 13px;
  font-weight: 600;
  color: var(--fc-text);
  white-space: nowrap;
}
.fc-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px;
  border-radius: 20px;
  font-size: 10.5px;
  font-weight: 600;
  white-space: nowrap;
}
.fc-badge--open {
  background: var(--fc-open-bg);
  color: var(--fc-open);
}
.fc-badge--closed {
  background: var(--fc-closed-bg);
  color: var(--fc-closed);
}
.fc-q-action {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  flex-shrink: 0;
  width: 140px;
  border-left: 1px solid var(--fc-border);
  background: var(--fc-bg);
}
.fc-q-btn {
  font-size: 12px !important;
  white-space: nowrap;
}
.fc-q-all-closed {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--fc-open);
}
.fc-q-all-closed mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.fc-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 56px 24px;
}
.fc-loading__dots {
  display: flex;
  gap: 8px;
}
.fc-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--fc-brand);
  opacity: 0.3;
  animation: fc-pulse 1.2s ease-in-out infinite;
}
.fc-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.fc-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes fc-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.fc-loading p {
  margin: 0;
  font-size: 13px;
  color: var(--fc-muted);
}
/*# sourceMappingURL=fiscal-closure-list.component.css.map */
